import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useQueryClient } from "react-query";
import { MapPin } from "lucide-react";
import { getAllPropertiesSummary } from "@/utils/api";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const areas = [
  {
    name: "Dallas Fort Worth",
    image: "https://cdn.landivo.com/wp-content/uploads/2025/04/DFW.png",
    route: "/DFW",
  },
  {
    name: "Austin",
    image: "https://cdn.landivo.com/wp-content/uploads/2025/04/Austin.png",
    route: "/Austin",
  },
  {
    name: "Houston",
    image: "https://cdn.landivo.com/wp-content/uploads/2025/04/Houstin.png",
    route: "/Houston",
  },
  {
    name: "San Antonio",
    image: "https://cdn.landivo.com/wp-content/uploads/2025/04/SanAntonio.png",
    route: "/SanAntonio",
  },
  {
    name: "Other Areas",
    image: "https://cdn.landivo.com/wp-content/uploads/2025/04/others.jpg",
    route: "/OtherLands",
  },
];

const JVAreas = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handlePrefetch = () => {
    queryClient.prefetchQuery("allProperties", getAllPropertiesSummary);
  };

  return (
    <section className="bg-white py-14 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center sm:mb-14">
          <p className="text-xs font-semibold uppercase tracking-wide text-[#C1694F] sm:text-sm">
            Where We Partner
          </p>
          <h2 className="mt-2 text-2xl font-bold text-[#16213E] sm:text-4xl">
            Find Our Partnered Lands In Your Area
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-slate-600 sm:text-base">
            We're actively structuring joint venture deals with landowners across
            these Texas regions.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-6 lg:grid-cols-5">
          {areas.map((area) => (
            <motion.button
              key={area.name}
              type="button"
              onClick={() => navigate(area.route)}
              onMouseEnter={handlePrefetch}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              variants={fadeUp}
              className="group relative aspect-[4/5] overflow-hidden rounded-xl text-left ring-1 ring-black/5"
              id={`jv-areas-btn-${area.route.replace("/", "").toLowerCase()}`}
            >
              <img
                src={area.image}
                alt={area.name}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#101826]/90 via-[#101826]/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4">
                <p className="flex items-center gap-1 text-xs font-semibold text-white sm:text-sm">
                  <MapPin className="h-3.5 w-3.5 shrink-0 text-[#C1694F]" />
                  {area.name}
                </p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JVAreas;
